import React, { useContext, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Card, CardContent, MenuItem, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import { AppContext } from '@/AppContext';
import { renderBadgePDF_ToDataUrl } from '../../../../BadgeDetails/components/BadgeView/BadgeView';
import { saveAs } from 'file-saver';
import DropDownMenu from '@/components/DropDownMenu/DropDownMenu';
import PrintVisitors from '../../../../VisitorList/components/VisitorsToolbar/PrintVisitors';
import ColorPicker from 'components/ColorPicker/ColorPicker';
import { HelpHint } from 'components/HelpHint/HelpHint';
import Typography from '@mui/material/Typography';

const PREFIX = 'HallsTable';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  inner: `${PREFIX}-inner`,
  nameContainer: `${PREFIX}-nameContainer`,
  actions: `${PREFIX}-actions`,
  fab: `${PREFIX}-fab`,
  hint: `${PREFIX}-hint`,
  photo: `${PREFIX}-photo`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {
    overflowX: 'auto',
  },

  [`& .${classes.content}`]: {
    padding: 0,
  },

  [`& .${classes.inner}`]: {
    minWidth: 600,
  },

  [`& .${classes.nameContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.actions}`]: {
    justifyContent: 'flex-end',
  },

  [`& .${classes.fab}`]: {
    margin: theme.spacing(1),
  },

  [`& .${classes.hint}`]: {
    marginLeft: 10,
    height: 16,
    width: 16,
    minHeight: 16,
  },

  [`& .${classes.photo}`]: {
    maxWidth: '70px',
    maxHeight: '70px',
    borderRadius: '7%',
  },
}));

const HallsTable = props => {
  const { className, meetupId, halls, handleDelete, ...rest } = props;

  if (!halls) {
    return null;
  }

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Название</TableCell>
                <TableCell>Как добраться</TableCell>
                <TableCell>Фото</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {halls.map((hall, i) => (
                <TableRow className={classes.tableRow} hover key={hall.hallId}>
                  <TableCell>
                    <RouterLink to={'/m/' + meetupId + '/program/hall/id/' + hall.hallId}>
                      <Typography style={{ fontWeight: 'bold' }}>{hall.name}</Typography>
                    </RouterLink>
                  </TableCell>
                  <TableCell>
                    <ListItemText primary={hall.location} />
                  </TableCell>
                  <TableCell>
                    {hall.imageId && <img className={classes.photo} src={'/api/image/' + hall.imageId} alt={'Схема'} />}
                  </TableCell>
                  <TableCell style={{ textAlign: 'center', width: '100px' }}>
                    <DropDownMenu data-test-id='hall-menu'>
                      <MenuItem>
                        <RouterLink
                          to={'/m/' + meetupId + '/program/hall/id/' + hall.hallId}
                          data-test-id='hall-menu-edit'
                        >
                          <ListItemText primary='Редактировать' />
                        </RouterLink>
                      </MenuItem>
                      <MenuItem onClick={() => handleDelete(meetupId, hall.hallId)} data-test-id='hall-menu-delete'>
                        <ListItemText primary='Удалить' />
                      </MenuItem>
                    </DropDownMenu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </StyledCard>
  );
};

HallsTable.propTypes = {
  className: PropTypes.string,
  halls: PropTypes.array.isRequired,
  handleDelete: PropTypes.func,
};

export default HallsTable;
